import { Link } from 'react-router-dom';

// Legal/informational pages now live on the site itself (the landing app is dismessa).
const FOOTER_GROUPS: { title: string; links: { to: string; label: string }[] }[] = [
  {
    title: 'Klaro7',
    links: [
      { to: '/chi-siamo', label: 'Chi Siamo' },
      { to: '/carta-valori', label: 'Carta dei Valori' },
      { to: '/come-selezioniamo-i-consulenti', label: 'Come selezioniamo i consulenti' },
      { to: '/lavora-con-noi', label: 'Lavora con noi' },
      { to: '/faq', label: 'Domande Frequenti' },
    ],
  },
  {
    title: 'Trasparenza',
    links: [
      { to: '/guide', label: 'Guida ai primi passi' },
      { to: '/codice-etico', label: 'Codice Etico' },
      { to: '/policy-recensioni', label: 'Policy Recensioni' },
      { to: '/risoluzione-controversie', label: 'Risoluzione Controversie' },
    ],
  },
  {
    title: 'Legale',
    links: [
      { to: '/condizioni-generali', label: 'Condizioni Generali' },
      { to: '/privacy', label: 'Privacy Policy' },
      { to: '/cookie-policy', label: 'Cookie Policy' },
      { to: '/note-legali', label: 'Note Legali' },
    ],
  },
];

export function Footer() {
  return (
    <footer className="mt-12 border-t border-neutral-200 bg-white/60 px-4 py-10">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link
              to="/"
              className="inline-flex h-24 w-24 shrink-0 items-center justify-center rounded-full bg-brand-navy p-3"
            >
              <img
                src="/images/logo-clean.png"
                alt="Klaro7"
                className="max-h-full max-w-full object-contain"
              />
            </Link>
            <p className="mt-3 text-xs text-neutral-400">
              Consulenza di cartomanzia online, etica e trasparente.
            </p>
          </div>

          {/* Link groups */}
          {FOOTER_GROUPS.map((group) => (
            <nav key={group.title} aria-label={group.title}>
              <p className="text-xs font-semibold uppercase tracking-wide text-neutral-400">
                {group.title}
              </p>
              <ul className="mt-3 space-y-2">
                {group.links.map(({ to, label }) => (
                  <li key={to}>
                    <Link
                      to={to}
                      className="text-sm font-medium text-neutral-500 transition-colors hover:text-brand-teal"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <p className="mt-10 border-t border-neutral-200 pt-6 text-center text-xs text-neutral-400">
          © {2026} Klaro7 S.r.l.s. — Consulenza di Cartomanzia Online. Tutti i diritti riservati.
        </p>
        <p className="mt-3 text-center text-[11px] leading-relaxed text-neutral-400">
          Alcune immagini del sito sono generate con intelligenza artificiale e hanno finalità
          puramente illustrativa.{' '}
          <Link to="/note-legali" className="underline transition-colors hover:text-brand-teal">
            Maggiori informazioni
          </Link>
        </p>
      </div>
    </footer>
  );
}
